module.exports = __webpack_public_path__ + "static/14-bfe08800f9c1c7a71ea465da7a961a1c.jpg";